import { AxiosPromise } from 'axios'
import { AppApiResponseData } from '../types/api'
import http from './http'
import { AlertUnion } from '../types/alert'
import { HandleAlertReqBody } from '../types/patientRecentAlerts'

export function patientsRecent(
	patientID: string
): AxiosPromise<AppApiResponseData<Array<AlertUnion>>> {
	return http({
		method: 'GET',
		url: `/p/patient/${patientID}/recentAlerts`,
	})
}

export function getAllTypes(): AxiosPromise<
	AppApiResponseData<Array<AlertUnion>>
> {
	return http({
		method: 'GET',
		url: '/s/alerts',
	})
}

export function getOrgAdminAlerts(): AxiosPromise<
	AppApiResponseData<Array<AlertUnion>>
> {
	return http({
		method: 'GET',
		url: '/s/alerts?orgAlerts=true',
	})
}

export function handleAlerts(
	patientID: string,
	data: HandleAlertReqBody
): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'POST',
		url: `/p/patient/${patientID}/handleAlerts`,
		data,
	})
}

export function seen(alertId: string): AxiosPromise<AppApiResponseData> {
	return http({
		method: 'PUT',
		url: `/m/event/seen/${alertId}`,
		data: {
			id: alertId,
		},
	})
}
